export function arrify<T>(param: T | T[]): T[] {
  return Array.isArray(param) ? param : [param]
}

export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object
      ? RecursivePartial<T[P]>
      : T[P]
}
